import { render, staticRenderFns } from "./UpdateBrandConfig.vue?vue&type=template&id=157db919&scoped=true"
import script from "./UpdateBrandConfig.vue?vue&type=script&lang=js"
export * from "./UpdateBrandConfig.vue?vue&type=script&lang=js"
import style0 from "./UpdateBrandConfig.vue?vue&type=style&index=0&id=157db919&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157db919",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('157db919')) {
      api.createRecord('157db919', component.options)
    } else {
      api.reload('157db919', component.options)
    }
    module.hot.accept("./UpdateBrandConfig.vue?vue&type=template&id=157db919&scoped=true", function () {
      api.rerender('157db919', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/brandname/UpdateBrandConfig.vue"
export default component.exports